// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IChatHintSchema {
  /** Ключ аналитики **/
  analyticsKey: EAnalyticsKey;
  /** Текст кнопки **/
  buttonText: string;
  /** Текст сообщения **/
  messageText: string;
  /** Payload для отправки вместе с сообщением **/
  payload?: EPayload;
}
export enum EAnalyticsKey {
  /** Есть предоплата? **/
  'AdvancePayment' = 'advancePayment',
  /** Свободные даты **/
  'AvailableDates' = 'availableDates',
  /** Можно забронировать? **/
  'BookingOk' = 'bookingOk',
  /** Кадастровый номер **/
  'CadastralNumber' = 'cadastralNumber',
  /** Можно с детьми? **/
  'ChildrenOk' = 'childrenOk',
  /** Свяжитесь со мной **/
  'ContactMe' = 'contactMe',
  /** Сколько за сутки? **/
  'DailyPrice' = 'dailyPrice',
  /** Дадите скидку? **/
  'GiveDiscount' = 'giveDiscount',
  /** Есть скидки? **/
  'HaveDiscount' = 'haveDiscount',
  /** Ещё сдаёте? **/
  'IsActual' = 'isActual',
  /** На месяц сдаёте? **/
  'MonthlyRent' = 'monthlyRent',
  /** Можно ещё фото? **/
  'MorePhoto' = 'morePhoto',
  /** Хочу скидку на ипотеку **/
  'MortgageDiscountSecondary' = 'mortgageDiscountSecondary',
  /** Согласны на ипотеку? **/
  'MortgageOk' = 'mortgageOk',
  /** Условия ипотеки **/
  'MortgageTerms' = 'mortgageTerms',
  /** Можно с животными? **/
  'PetsOk' = 'petsOk',
  /** Ещё продаёте? **/
  'StillSelling' = 'stillSelling',
  /** Хочу посмотреть **/
  'WhenSee' = 'whenSee',
}
export enum EPayload {
  /** Приходит по нажатию на кнопку банера субсидированной ипотеки **/
  'SubsidisedMortgage' = 'subsidisedMortgage',
}
